import React from 'react'
import { ActionIcon } from '../../../model'
import { useTheme, makeStyles, IconButton, Tooltip } from '@material-ui/core'
import { styles } from './dataTableActionIcon.styles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ActionIconColors } from '../../../model/enums'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

export interface DataTableActionIconProps {
  item: any
  actionIcon: ActionIcon
  clickHandler?: Function
  tooltip?: string
  isLoading?: boolean
  hasPermission?: boolean
}

export const DataTableActionIcon: React.FC<DataTableActionIconProps> = ({
  item,
  actionIcon,
  clickHandler,
  tooltip,
  isLoading,
  hasPermission
}) => {
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  const getSuitableColor = (color: ActionIconColors, handler: Function | undefined) => {
    if (handler !== undefined && color === ActionIconColors.DISABLED) {
      return classes.primary
    }

    switch (color) {
      case ActionIconColors.PRIMARY: {
        return classes.primary
      }
      case ActionIconColors.SECONDARY: {
        return classes.secondary
      }
      case ActionIconColors.WARNING: {
        return classes.warning
      }
      case ActionIconColors.INFO: {
        return classes.info
      }
      case ActionIconColors.ERROR: {
        return classes.error
      }
      case ActionIconColors.DISABLED: {
        return classes.grey
      }
    }
  }

  return (
    <>
      {isLoading ? (
        <IconButton color={undefined} size="small">
          <FontAwesomeIcon
            className={getSuitableColor(ActionIconColors.DISABLED, undefined)}
            icon={faSpinner}
            spin
          />
        </IconButton>
      ) : (
        <Tooltip title={tooltip !== undefined ? tooltip : ''}>
          {hasPermission === undefined || hasPermission === true ? (
            <div>
              <IconButton
                color={undefined}
                size="small"
                disabled={clickHandler === undefined}
                onClick={() => {
                  clickHandler && clickHandler(item)
                }}
              >
                <FontAwesomeIcon
                  className={getSuitableColor(actionIcon.color, clickHandler)}
                  icon={actionIcon.icon}
                />
              </IconButton>
            </div>
          ) : (
            <div>
              <IconButton color={undefined} size="medium" disabled>
                <FontAwesomeIcon icon={actionIcon.icon} />
              </IconButton>
            </div>
          )}
        </Tooltip>
      )}
    </>
  )
}
